<template>
    <SOSlotModal
        :modal-title="getDataAction === '' ? 'Tambah Pengingat' : 'Ubah Pengingat'"
        :modal-id="id"
        :no-padding="true"
        @close="close"
    >
        <template v-slot:modal-body>
            <div class="d-flex bg-yellow align-items-center p-x-20 p-y-8 w-100">
                <img src="@/assets/icons/alert-circle-yellow.svg" class="p-r-12" alt="" />
                <div class="f-regular f-12 f-c-midgrey">
                    Pesan pengingat dikirim sistem secara otomatis melalui WA. Setiap pengiriman pesan akan dikenakan
                    <b>biaya 150 M-coin jika menggunakan perangkat smartlink.</b> Tapi
                    <b>
                        kalau menggunakan WA Autosender akan mengurangi kuota Wa Autosender. Jika kuotanya habis cukup
                        dikenakan biaya 125 M-coin
                    </b>
                </div>
            </div>
            <div class="p-x-20 p-y-16" @click="hideSearchSelect2">
                <SOInputSelect
                    class="p-d-12"
                    :title="'Ingatkan pada'"
                    :selected="reminderData.reminder"
                    :options="options"
                    :placeholder="'Pilih waktu...'"
                    @option-selected="
                        (val) => {
                            reminderData.reminder = val;
                        }
                    "
                />
                <!-- <SOInputTime
					v-if="reminderData.reminder.toString() !== '1'"
					:title="'Waktu pengiriman'"
					:value="getDataAction !== '' ? reminderData.time : ''"
					@get-time="getTime"
				/> -->
                <div class="f-regular f-12 f-c-midgrey m-t-4">
                    Waktu pengiriman menyesuaikan dengan zona waktu server pada sistem (WIB).
                </div>
            </div>
        </template>
        <template v-slot:modal-footer>
            <div class="p-x-20 p-y-16">
                <SOButton
                    :text="getDataAction === '' ? 'Tambah' : 'Ubah'"
                    :outline="true"
                    :full="true"
                    :disable="pageSetting.btn.save.disabled"
                    :loading="pageSetting.btn.save.loading"
                    @action="action"
                />
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputTime from "@/so-components/global/input/SOInputTime";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "ReminderMasaAktifModal",
    components: {
        SOSlotModal,
        SOInputSelect,
        SOInputTime,
        SOButton,
    },
    computed: {
        ...mapGetters("pengaturanUmumModule", {
            reminderOption: "reminderOption",
            reminderInfo: "reminderInfo",
        }),
    },
    props: {
        getDataAction: {
            type: String,
            default: "",
        },
        submitAction: {
            type: String,
            default: "",
        },
        reminderId: {
            type: String,
            default: "",
        },
        reminderType: {
            type: String,
            default: "",
        },
        reminderAction: {
            type: String,
            default: "",
        },
        idcountdownMaster: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            id: "modal-pengingat",
            pageSetting: {
                btn: {
                    save: {
                        disabled: false,
                        loading: false,
                    },
                },
            },
            options: [],
            reminderData: {
                reminder: "1",
                time: "",
            },
        };
    },
    mounted() {
        $("#" + this.id).modal("show");
        this.getOption();
    },
    methods: {
        ...mapActions("pengaturanUmumModule", {
            getInfo: "getReminderInfo",
        }),
        close() {
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
        async getDetail() {
            const res = await this.$store.dispatch("pengaturanUmumModule/getDetailReminder", {
                idpengingat: this.reminderId,
                type: this.reminderType,
            });
            if (!res.success) {
                this.$toast.error(res.err);
                return;
            }

            this.reminderData.reminder = res.data.idcountdown_master;
            // this.reminderData.time = res.data.sending_time.substr(0, 5);
        },
        async getOption() {
            if (this.reminderId !== "" && this.reminderType != "poin") await this.getDetail();

            const res = await this.$store.dispatch("pengaturanUmumModule/getReminderOption");
            if (!res.success) {
                this.$toast.error(res.err);
                return;
            }
            this.reminderOption.forEach((v) => {
                if (this.reminderType === "emoney") {
                    console.log(
                        this.reminderAction,
                        v.id,
                        parseInt(this.reminderData.reminder),
                        v.id === parseInt(this.reminderData.reminder)
                    );
                    if (this.reminderAction === "edit" && v.id === parseInt(this.reminderData.reminder)) {
                        this.options = [
                            ...this.options,
                            {
                                id: v.id,
                                text: v.nama,
                            },
                        ];
                    }
                    if (
                        this.reminderInfo.data_reminder_emoney.filter((vv) => vv.idcountdown_master === v.id).length ===
                        0
                    ) {
                        this.options = [
                            ...this.options,
                            {
                                id: v.id,
                                text: v.nama,
                            },
                        ];
                    }
                } else {
                    if (this.reminderAction === "edit" && v.id === parseInt(this.reminderData.reminder)) {
                        this.options = [
                            ...this.options,
                            {
                                id: v.id,
                                text: v.nama,
                            },
                        ];
                    }
                    if (
                        this.reminderInfo.data_reminder_deposit.filter((vv) => vv.idcountdown_master === v.id)
                            .length === 0
                    ) {
                        this.options = [
                            ...this.options,
                            {
                                id: v.id,
                                text: v.nama,
                            },
                        ];
                    }
                }
            });
            if (this.reminderType == 'poin') {
                this.reminderData.reminder = this.idcountdownMaster;
            }
        },
        async action() {
            let form = new FormData();
            form.append("idcountdown_master", this.reminderData.reminder);
            form.append("sending_time_reminder", this.reminderData.time);
            this.pageSetting.btn.save.disabled = true;
            this.pageSetting.btn.save.loading = true;
            let payload;
            if (this.getDataAction !== "") {
                payload = {
                    idpengingat: this.reminderId,
                    type: this.reminderType,
                    form: form,
                };
            } else {
                payload = form;
            }
            if (this.reminderType == 'poin') {
                payload = {
                    idcountdown_master: parseInt(this.reminderData.reminder),
                    id: this.reminderId,
                }
            }
            const res = await this.$store.dispatch(this.submitAction, payload);
            if (res.success) {
                this.$toast.success(res.msg);
                this.close();
            } else {
                this.$toast.error(res.err);
            }
            await this.getInfo();
            this.pageSetting.btn.save.disabled = false;
            this.pageSetting.btn.save.loading = false;
        },
        getTime(val) {
            this.reminderData.time = val;
        },

        hideSearchSelect2() {
            $(".select2-search").hide();
        },
    },
    beforeDestroy() {
        $(".select2-search").show();
    },
};
</script>
